import React from "react";

export default function ImageLoader({ src = "", style = {} }) {
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    if (!src) return setLoading(true);
    const img = new Image();
    img.onload = () => setLoading(false);
    img.src = src;
  }, [src]);

  return loading ? (
    <div className="shimmer" />
  ) : (
    <img src={src} style={style} alt="" height="100%" width="100%" />
  );
}
